import {
    AllocationElementDiagramAnchor,
    AllocationElementDiagramVersion,
} from 'src/models/anchor-and-version/allocation-element-diagram.model';
import { Component } from '@angular/core';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';

@Component({
    selector: 'app-crud-allocation-element-diagram-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudAllocationElementDiagramModalComponent extends CrudModalAbstractComponent<
    AllocationElementDiagramAnchor,
    AllocationElementDiagramVersion
> {
    public modalProps: ModalProps = {
        title: 'Allocation Element Diagram',
        validateNameFormat: false,
        anchorFields: [
            {
                field: 'userFunctionAnchorKey',
                label: 'User Function',
                type: 'lazy-dropdown',
                required: true,
                order: 2,
            },
        ],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 3 },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 4 },
        ],
    };
}
